"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.downloadFile = exports.fakeApiCall = exports.toFormData = exports.toFormString = exports.fetchUploadFile = exports.fetchPostActionRaw = exports.fetchPostAction = exports.fetchBlobByFile = exports.fetchBlobByUrl = exports.fetchToJson = exports.fetchToResponse = exports.fetchToBlob = exports.getFilenameFromResponse = exports.validateResponse = exports.getAdditionalHeaders = exports.exampleApiCall = exports.simulateFetch = exports.delay = exports.getPasportUrlConstant = exports.getCommonApiUrl = exports.getPasportApiUrl = void 0;
const fetchWrappers_1 = require("./fetchWrappers");
const AuthProvider_1 = require("../Auth/providers/AuthProvider");
const Config_1 = require("../Config");
const getPasportApiUrl = (url) => {
    return `${(0, Config_1.getConfigValue)('PASPORT_API_BASE_PATH')}/${url}`;
};
exports.getPasportApiUrl = getPasportApiUrl;
const getCommonApiUrl = (url) => {
    return `${(0, Config_1.getConfigValue)('COMMON_API_BASE_PATH')}/${url}`;
};
exports.getCommonApiUrl = getCommonApiUrl;
const getPasportUrlConstant = (name) => {
    switch (name) {
        case 'APPLICATION_MANUAL_URL':
            return (0, exports.getPasportApiUrl)("manual");
        case 'POST_REQUEST_URL':
            return (0, exports.getPasportApiUrl)("PocetObjektu/post");
        case 'UPLOAD_REQUEST_URL':
            return (0, exports.getPasportApiUrl)("zap/post");
        case 'FILE_REQUEST_URL':
            return (0, exports.getCommonApiUrl)("index.php");
    }
    throw new Error(`Unknown PasportUrlConstant: ${name}`);
};
exports.getPasportUrlConstant = getPasportUrlConstant;
const delay = async (time) => {
    return new Promise((resolve) => {
        setTimeout(() => {
            resolve(true);
        }, time);
    });
};
exports.delay = delay;
const simulateFetch = async () => {
    return (0, exports.delay)(200);
};
exports.simulateFetch = simulateFetch;
const exampleApiCall = async (param) => {
    return (0, exports.delay)(1000).then(() => {
        if (param === "bolek")
            throw "nothing herer";
    }).then(() => param + " " + param);
};
exports.exampleApiCall = exampleApiCall;
const mockUserHeaders = {
    token: "eyJhbGciOiJSUzI1NiIsInR5cCI6IkpXVCIsImtpZCI6IjNsMWZhanZob3gifQ.eyJzdWIiOjI1NjAsImV4cCI6MTY5MjUyODY1OCwiYXVkIjpbIm1hcHMiXSwiY2xpZW50X2lkIjoicGFzcG9ydC1keiIsImp0aSI6IjQ5ZTg4YjdiOWIiLCJzY29wZSI6WyJtYXBzIiwib3BlbmlkIl0sIm51dHMiOiJsYXUyIiwiZ2VvY29kZSI6IjU0NzQ5MiIsInJvbGUiOiJhZG1pbiIsImlhdCI6MTY5MjUyNTk1NywiaXNzIjoiaHR0cHM6Ly9hdXRoLnNtc2RhdGEuY3oifQ.Czy5fa3jhd3wbcpLowjvn3n5OfLXhStx6QIIYm_IkNXGGmKSbpUuQcCPA0OcQdgWroj2z7L97Lk5E_bSUiUqchfZc0a23ctWK9yfhTNiGD2HNl-KvN0BvcSVF9a0c0xNyVZMkqJcAV2mbiefMTazcPLpKO9IqBiF3ZXEXi_UukE5ag0wFw_lW5h8RBaKOQwVCM5WFB-8jvqSM-aH-UgOtKF0JMltZwmak8KUVX7URHFll-kF4mG7cfNn8SBZuR3SjYm3bLnDM8-UheZw4dkIb-jJZHDsN3lmCmn830DJ5XUk7pqMp5nMZdZBWIWLuN4F53CG--eJjzGq8vhObm8-Uw",
    activeLau: 547492
};
const getAdditionalHeaders = (options) => {
    const state = (0, AuthProvider_1.getAuthInnerState)();
    const storedOptions = {
        token: state.tokens?.accessToken,
        activeLau: state.activeLau?.id
    };
    const actualOptions = { ...storedOptions, ...options };
    return {
        'Authorization': actualOptions.token ? `Bearer ${actualOptions.token ?? ''}` : '',
        'x-pasport-lau': actualOptions.activeLau?.toString() ?? ''
    };
};
exports.getAdditionalHeaders = getAdditionalHeaders;
const validateResponse = (response, requestType) => {
    console.log("validateResponse start", response);
    if (!response.ok) {
        console.log("validateResponse start in error");
        throw {
            errorCode: response.status,
            message: response.statusText,
            requestType: requestType
        };
        console.log("validateResponse start after error");
    }
    return response;
};
exports.validateResponse = validateResponse;
const normalizeUrl = (url) => {
    return url.replace(/ /g, '@');
};
const getFilenameFromResponse = (response) => {
    const contentDisposition = response.headers.get('content-disposition');
    if (contentDisposition) {
        const match = contentDisposition.match(/filename=(.+)/);
        if (match) {
            return match[1];
        }
    }
    return null;
};
exports.getFilenameFromResponse = getFilenameFromResponse;
const fetchToBlob = async (url, isRelative = true, headerOptions) => {
    return (0, exports.fetchToResponse)(url, isRelative, headerOptions).then(response => response.blob());
};
exports.fetchToBlob = fetchToBlob;
const fetchToResponse = async (url, isRelative = true, headerOptions) => {
    const getUrl = isRelative ? (0, exports.getPasportApiUrl)(url) : url;
    //await delay(2000);
    return fetch(getUrl, {
        mode: 'cors',
        headers: {
            ...(0, exports.getAdditionalHeaders)(headerOptions)
        }
    })
        .then(response => (0, exports.validateResponse)(response, 'get'));
};
exports.fetchToResponse = fetchToResponse;
const fetchToJson = async (url, isRelative = true, headerOptions) => {
    const rawUrl = isRelative ? (0, exports.getPasportApiUrl)(url) : url;
    const getUrl = normalizeUrl(rawUrl);
    //await delay(2000);
    console.log("fetch requested");
    return fetch(getUrl, {
        mode: 'cors',
        headers: {
            ...(0, exports.getAdditionalHeaders)(headerOptions)
        }
    })
        .then(response => (0, exports.validateResponse)(response, 'get'))
        .then((response) => response.json())
        .then(response => {
        if (response.status !== 'success') {
            throw {
                errorCode: 401,
                message: response.errorMessage,
                requestType: 'get'
            };
        }
        return response;
    });
    // .then((response : ResponseDto) => {
    //     console.log("response for",getUrl, response)
    //     return apiJsonToResponse(response).data;
    // })
    // .catch(
    //     error => {
    //         return getUnknownErrorResponse(error).data
    //     }
    // );
};
exports.fetchToJson = fetchToJson;
const apiJsonToResponse = (response) => {
    const status = response?.status;
    if (status === 'success') {
        return {
            data: response?.data,
        };
    }
    else {
        return {
            data: null,
            error: {
                message: response?.message
            }
        };
    }
};
const getUnknownErrorResponse = (error) => {
    return {
        data: null,
        error: {
            message: "Neznámá chyba serveru",
            code: 500
        }
    };
};
const fetchBlobByUrl = async (url) => {
    return (0, exports.fetchPostActionRaw)('showFile', {
        pasport: (0, Config_1.getConfigValue)('PASPORT_ID'),
        ulozeni: url
    }, (0, exports.getPasportUrlConstant)('FILE_REQUEST_URL')).then((response) => response.blob());
    // return fetch(getUrl, {
    //     mode: 'cors',
    //     headers: {
    //         'Access-Control-Allow-Origin': '*',
    //         ...getAdditionalHeaders()
    //     }
    // })
    //     .then((response) => response.blob())
};
exports.fetchBlobByUrl = fetchBlobByUrl;
const fetchBlobByFile = async (file) => {
    if (file.path)
        return (0, exports.fetchBlobByUrl)(`${file.path}`);
    else
        return (0, exports.fetchBlobByUrl)(file.url ?? "");
};
exports.fetchBlobByFile = fetchBlobByFile;
const fetchPostAction = async (action, data, url, headerOptions) => {
    return (0, exports.fetchPostActionRaw)(action, data, url, headerOptions)
        .then(response => (0, exports.validateResponse)(response, "post"))
        .then(response => {
        console.log("response before json, action " + action, response, data);
        return response.json();
    })
        .then(response => {
        console.log("response for action " + action, response, data);
        return apiJsonToResponse(response);
    });
};
exports.fetchPostAction = fetchPostAction;
const fetchPostActionRaw = async (action, data, url, headerOptions) => {
    const getUrl = !url ? (0, exports.getPasportUrlConstant)('POST_REQUEST_URL') : url;
    const allData = { ...data, method: action };
    console.log("sending action request with", allData);
    const body = (0, exports.toFormString)(allData);
    return fetch(getUrl, {
        method: "POST",
        mode: 'cors',
        headers: {
            "Content-Type": "application/x-www-form-urlencoded",
            ...(0, exports.getAdditionalHeaders)(headerOptions)
            //'Content-Type': 'application/json'
        },
        body: body
    });
};
exports.fetchPostActionRaw = fetchPostActionRaw;
const fetchUploadFile = async (fileUpload, data) => {
    const action = "uploadFile";
    const formData = (0, exports.toFormData)(data);
    formData.append('method', action);
    formData.append('PXname', fileUpload.name);
    formData.append('image', fileUpload.file);
    const getUrl = (0, exports.getPasportUrlConstant)('UPLOAD_REQUEST_URL');
    const allData = { ...data, method: action };
    console.log("sending action request with", allData);
    console.log("formData", formData, fileUpload.file);
    const body = (0, exports.toFormString)(allData);
    return fetch(getUrl, {
        method: "POST",
        mode: 'cors',
        headers: {
            ...(0, exports.getAdditionalHeaders)()
            //"Content-Type":"application/x-www-form-urlencoded"
            //'Content-Type': 'application/json'
        },
        body: formData
    })
        .then(response => response.json())
        .then(response => {
        console.log("response for action " + action, response, data);
        return apiJsonToResponse(response);
    }).catch(error => getUnknownErrorResponse(error));
};
exports.fetchUploadFile = fetchUploadFile;
const toFormString = (value) => {
    return Object.entries(value).map(([key, value]) => encodeURIComponent(key) + '=' + encodeURIComponent(value)).join('&');
};
exports.toFormString = toFormString;
const toFormData = (data) => {
    const formData = new FormData();
    Object.entries(data).map(([key, value]) => {
        formData.append(key, value);
    });
    return formData;
};
exports.toFormData = toFormData;
const fakeApiCall = (data) => {
    return (0, exports.delay)(200).then(() => {
        if (data)
            return data;
        else
            throw "no data";
    });
};
exports.fakeApiCall = fakeApiCall;
const downloadFile = async (url, fileName, overriderServerFileName = false) => {
    return (0, fetchWrappers_1.fetchFile)(url).then((response) => ({
        blob: response.blob,
        filename: overriderServerFileName ? fileName : response.filename || fileName
    }));
    /*const actualUrl = `${API_SERVER_URL}/${url}`
    const link = document.createElement('a');
    link.target = "_blank";
    link.href = actualUrl;
    link.setAttribute(
        'download',
        fileName,
    );

    document.body.appendChild(link);
    link.click();
    link.parentNode?.removeChild(link);*/
};
exports.downloadFile = downloadFile;
